import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import vuex from '../../store/index'

export function procesarXLS() {
   
    function procesarArchivo(archivo) {

        const file = archivo;
        let prodItem = {
            cantidad: 1,
            nombre:'',
            preciocompra: 0,
            descuento: 0,
            precioventa: 0,
            total: 0,
            idarticulo: 1,
        }
        let productosItem = []
        if (!file) return;
        
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (e) => {
            
            const binarystr = new Uint8Array(e.target.result);
            const wb = XLSX.read(binarystr, { type: 'array', raw: true, cellFormula: false });

            const wsname = wb.SheetNames[0];
            productosItem = []
            XLSX.utils.sheet_to_json(wb.Sheets[wsname]).forEach((value) => {
                prodItem.cantidad = value['cantidad']
                prodItem.descuento = value['descuento'] || 0
                prodItem.precioventa = value['precio']
                prodItem.total = value['subtotal']
                buscarProducto(value['codigo'])
            });

           vuex.dispatch("setItemsCotizacion",productosItem);
           productosItem=[]
            Swal.close();
        };

        function buscarProducto(cod){
           const producto = vuex.getters.getProductosActivos.find(el=>el.articulo.codigo === cod)
           if(!producto)return
           prodItem.preciocompra = producto.articulo.preciocompra
           prodItem.nombre = producto.articulo.nombre
           prodItem.idarticulo = producto.articulo.idarticulo
           productosItem.push(prodItem)
           prodItem={}

        }
    }

    


    return { procesarArchivo };
}
